import { useCallback, useState } from "react";
import { generarContratoInscripcion, descargarContratoInscripcion } from "../../../../services/contratosInscripcionService";
import { showToast } from "../../../../utils/showToast";

export default function useContratoInscripcion() {
  const [loading, setLoading] = useState({ id: null, type: null });

  const resetLoading = () => setLoading({ id: null, type: null });

  const generar = useCallback(async (matricula) => {
    const matriculaId = matricula?.id ?? matricula;
    if (!matriculaId) return;

    setLoading({ id: matriculaId, type: "generar" });
    try {
      await generarContratoInscripcion(matriculaId);
      showToast({ type: "success", message: "Contrato generado. Iniciando descarga..." });
      await descargarContratoInscripcion(matriculaId);
    } catch (err) {
      const message = err?.message || "No se pudo generar el contrato.";
      showToast({ type: "danger", message });
    } finally {
      resetLoading();
    }
  }, []);

  const descargar = useCallback(async (matricula) => {
    const matriculaId = matricula?.id ?? matricula;
    if (!matriculaId) return;

    setLoading({ id: matriculaId, type: "descargar" });
    try {
      await descargarContratoInscripcion(matriculaId);
    } catch (err) {
      const message = err?.message || "No se pudo descargar el contrato.";
      showToast({ type: "danger", message });
    } finally {
      resetLoading();
    }
  }, []);

  return {
    generar,
    descargar,
    loadingId: loading.id,
    loadingType: loading.type,
  };
}
